import { useCallback, useEffect, useMemo, useState } from "react";

import { Box, Card } from "@mui/material";

import { throttle } from "Helper/general";

interface IProps {
  visible: boolean;
  children: React.ReactNode;
}
type Position = { x: number; y: number };

export default function HintBox({ visible, children }: IProps) {
  const [position, setPosition] = useState<Position>();

  const handleMouseMove = useCallback((event: MouseEvent): void => {
    const { pageX, pageY } = event;
    setPosition({ x: pageX + 30, y: pageY - 30 });
  }, []);
  const eventFunction = useMemo(
    () =>
      throttle(function (event: MouseEvent) {
        handleMouseMove(event);
      }, 100),
    []
  );

  useEffect(() => {
    if (visible) {
      document.addEventListener("mousemove", eventFunction);
    } else {
      document.removeEventListener("mousemove", eventFunction);
    }
  }, [visible]);

  return (
    <Box
      sx={{
        position: "absolute",
        top: `${position?.y}px`,
        right: `${position?.x}px`,
        opacity: visible ? 0.9 : 0,
        transition: "all 0.1s",
        pointerEvents: "none",
      }}
    >
      <Card sx={{ p: 2 }}>{children}</Card>
    </Box>
  );
}
